import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'
import {
  NotificationBar,
  NotificationBarSubtitle,
  NotificationBarTitle,
} from '@/components/NotificationBar'
import { byDesign } from '@/infra/design'
import imgServiceItemsCompleteUrl from '@/assets/misc/img_service-items-complete.svg'
import StripeSuccessIllustration from '@/components/SpotIllustration/StripeSuccessIllustration'

export interface BookkeepingCompleteJobDialogProps {
  showing: boolean
  onClose: () => unknown
  onSubmit: () => unknown
  isSubmitPending: boolean
  isCorporateMode: boolean
  isScopeChangeRequestPending: boolean
}

export function BookkeepingCompleteJobDialog({
  showing,
  onClose,
  onSubmit,
  isSubmitPending,
  isCorporateMode,
  isScopeChangeRequestPending,
}: BookkeepingCompleteJobDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isSubmitPending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!isCorporateMode && (
            <ModalSheetContentIllustration
              src={imgServiceItemsCompleteUrl}
              illustration={byDesign(undefined, StripeSuccessIllustration)}
              alt="Illustration of a checklist"
            />
          )}
          <ModalSheetContentTitle>
            All service items are complete
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            If you finished the last service item, please proceed to complete
            this job.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      {isScopeChangeRequestPending && (
        <NotificationBar centered type="error">
          <NotificationBarTitle>Pending updates:</NotificationBarTitle>
          <NotificationBarSubtitle>
            Unable to close due to pending job scope changes
          </NotificationBarSubtitle>
        </NotificationBar>
      )}
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            onPress={onClose}
            isDisabled={isSubmitPending}
          />
          <Button
            label="Complete Job"
            variant="primary"
            onPress={onSubmit}
            testId="complete-bookkeeping-dialog-close-job-button"
            isPending={isSubmitPending}
            isDisabled={isScopeChangeRequestPending}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
